import React, { useEffect, useState } from "react"
import "../../SignIn/SignIn.scss"
import { FormGroups } from "../../../components/ReusableComponents/FormGroups/FormGroups"
import { FieldControl, FieldGroup } from "react-reactive-form"
import { TextInput } from "../../../components/UI/FormInput/FormInput"
import { messageService } from "../../../services/subscriberService"
import { accessTokenApi, resendVerifyEmail } from "../../../services/CallApi"
import { ErrorUI } from "../../../components/UI/Modals/Modals"

const VerifyEmail = ({
  userDetail,
  submitData,
  updateProfileData,
  ...props
}) => {
  useEffect(() => {
    console.log(userDetail.getRawValue())
    const interval = setInterval(() => {
      messageService.show = false
      accessTokenApi().then((res) => {
        updateProfileData(res.data)
      })
    }, 1000 * 10)
    return () => {
      clearInterval(interval)
    }
  }, [])

  const [editEmail, setEditEmail] = useState(false)

  useEffect(() => {
    if (editEmail) {
      userDetail.get("email").enable()
    } else {
      userDetail.get("email").disable()
    }
  }, [editEmail])

  const handleSubmit = (e) => {
    e.preventDefault()
    if (userDetail.get("email").valid) {
      submitData()
      setEditEmail(false)
    }
  }

  const ResendVerifyEmailLink = (e) => {
    resendVerifyEmail().then((response) => {
      if (response.status) {
        console.log("verify email sent")
        ErrorUI("A new verification link has been sent to your email address.")
      } else {
        console.log("verify email not sent")
      }
    })
  }

  return (
    <div className="formDetailContainer">
      {editEmail ? (
        <FieldGroup
          control={userDetail}
          render={({ get, invalid }) => (
            <form onSubmit={handleSubmit}>
              <React.Fragment>
                <p className="changeEmail">Change Your Email</p>
                <p className="descText">
                  Oops! You entered the wrong email address? Change it here:
                </p>
                <FormGroups>
                  <FieldControl
                    name="email"
                    render={TextInput}
                    meta={{
                      label: "Email address",
                      showLabel: false,
                      type: "email",
                      placeholder: "Email address",
                      placeHolderIcon: "emailInput",
                      valid: true,
                      showError: true,
                    }}
                  />
                </FormGroups>
                <div className="submitDiv">
                  <button
                    className={`${
                      get("email").invalid ? "disabled" : "enabled"
                    }`}
                    type="submit"
                  >
                    <p>Submit</p>
                  </button>
                </div>
              </React.Fragment>
            </form>
          )}
        />
      ) : (
        <React.Fragment>
          <p className="descText">
            Verify your email address through the link sent to
          </p>
          <div className="disabledEmail">{userDetail.getRawValue().email}</div>

          <p
            className="redSubHeading curserP"
            onClick={() => setEditEmail(true)}
          >
            Edit your Email Address
          </p>
          <hr />
          <p className="descText">
            Haven’t received an email yet?{" "}
            <span
              className="redSubHeading curserP"
              onClick={ResendVerifyEmailLink}
            >
              Resend Email
            </span>
          </p>
        </React.Fragment>
      )}
    </div>
  )
}

export default VerifyEmail
